import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Team from './team-model'
import { CreateTeamAsync, DeleteTeamAsync, LoadTeamsAsync } from './team-thunk'
const initialState: teamSliceState = {
  team: [],
  selected_team: '',
  is_loading_team: false,
  is_creating_team: false,
  is_deleting_team: false,
}
export interface teamSliceState {
  team: Team[]
  selected_team?: string
  is_loading_team: boolean
  is_creating_team: boolean
  is_deleting_team: boolean
}
export const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    setSelectedteam: (state, action) => {
      state.selected_team = action.payload
    },
    clearStateteam: (state) => {
      state.team = []
      state.is_loading_team = false
      state.is_creating_team = false
      state.is_deleting_team = false
    },
    mergeteam: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_team = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.team = merge(state.team, payload) as any
        }
      }
    },

    add_team: (state, action) => {
      if (action.payload) {
        state.team = [...state.team, action.payload]
      }
    },
    set_team: (state, action) => {
      let { key, value, id } = action.payload
      state.team = state.team.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTeamsAsync.pending, (state) => {
      state.is_loading_team = true
    })
    builder.addCase(LoadTeamsAsync.fulfilled, (state, action) => {
      state.is_loading_team = false
      if (action.payload) {
        state.team = action.payload
      }
    })
    builder.addCase(LoadTeamsAsync.rejected, (state) => {
      state.is_loading_team = false
    })
    builder.addCase(CreateTeamAsync.pending, (state) => {
      state.is_creating_team = true
    })
    builder.addCase(CreateTeamAsync.fulfilled, (state) => {
      state.is_creating_team = false
    })
    builder.addCase(CreateTeamAsync.rejected, (state) => {
      state.is_creating_team = false
    })
    builder.addCase(DeleteTeamAsync.pending, (state) => {
      state.is_deleting_team = true
    })
    builder.addCase(DeleteTeamAsync.fulfilled, (state, action) => {
      state.is_deleting_team = false
      if (state.team) {
        state.team = state.team.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteTeamAsync.rejected, (state) => {
      state.is_deleting_team = false
    })
  },
})

export const {
  clearStateteam,
  setSelectedteam,
  set_team,
  mergeteam,
  add_team,
} = teamSlice.actions

export const get_team =
  (id?: string) =>
  (state: {
    team: {
      team: Team[]
    }
  }): Team | null => {
    let temp = state?.team?.team?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.team?.team[0] || null
  }
export const get_selected_team = (state: {
  team: teamSliceState
}): Team | null => {
  let id = state?.team?.selected_team
  let temp = state?.team?.team?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_team = (state: {
  team: {
    team: Team[]
  }
}): Team[] => {
  let temp = state?.team?.team
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_team_busy = (state: { team: teamSliceState }) => {
  return (
    state?.team.is_deleting_team ||
    state?.team.is_loading_team ||
    state?.team.is_creating_team
  )
}
export const is_deleting_team_busy = (state: { team: teamSliceState }) => {
  return state?.team.is_deleting_team
}
export const is_loading_team_busy = (state: { team: teamSliceState }) => {
  return state?.team.is_loading_team
}
export const is_creating_team_busy = (state: { team: teamSliceState }) => {
  return state?.team.is_creating_team
}

export default teamSlice.reducer
